/**
 * GA4 view_item_list — watches every product-grid container on the page
 * (collection, search, related, recently-viewed, bestsell — anywhere a
 * card carries data-ga-list-id) and pushes an impression event as cards
 * appear, including cards added later by filters/sort/infinite-scroll or
 * an async fetch (xo-products-fetcher).
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];
  var seen = new WeakSet();

  function pushViewItemList(items, listId, listName) {
    if (!items.length) return;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: listId,
        item_list_name: listName,
        items: items
      }
    });
  }

  function scan(container) {
    var listId = container.getAttribute('data-ga-list-id') || '';
    var listName = container.getAttribute('data-ga-list-name') || '';
    var cards = container.querySelectorAll('xo-product[data-cs-il-sku]');
    var items = [];
    cards.forEach(function (card, i) {
      if (seen.has(card)) return;
      seen.add(card);
      items.push({
        item_id: card.getAttribute('data-cs-il-sku') || '',
        item_name: card.getAttribute('data-cs-il-title') || '',
        price: parseFloat(card.getAttribute('data-cs-il-price') || 0) / 100,
        index: i,
        item_list_id: listId,
        item_list_name: listName
      });
    });
    pushViewItemList(items, listId, listName);
  }

  function watch(container) {
    scan(container);
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        scan(container);
      });
    }).observe(container, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-ga-list-id]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
